/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import './Ruleta.css';

const Ruleta = ({ ruletaSize, onClickHandler }) => {
  let ruletaClass = '';

  if (ruletaSize === 'small') {
    ruletaClass = 'ruleta--small';
  }

  return (
    <div className={`ruleta__container ${ruletaClass}`}>
      <div className="triangulo">
          <img src={`${process.env.PUBLIC_URL}/img/triangulo.png`} className="triangulo__img" alt="" />
      </div>
      <div className="ruleta" id="ruleta" onClick={onClickHandler}>
        <img src={`${process.env.PUBLIC_URL}/img/ruleta.png`} alt="Ruleta" className="ruleta__img" id="ruleta__img" />
      </div>
    </div>
    );
};

export default Ruleta;

